
import EDTypography from '../../../../../../BaseComponents/Typography/EDTypography';
import { makeStyles } from 'tss-react/mui';
interface IProps {
  label: string;
  onClick: () => void;
  disableClickable?: boolean;
  testId?: string;
}

const useStyles = makeStyles()(
  theme =>
    ({
      container: {
        alignItems: 'center',
        padding: '8px 8px 0px 0px',
        width: '50%',
        boxSizing: 'border-box',
      },
      valueText: {
        cursor: 'pointer',
        color: theme.palette.primary.light,
        '&:hover strong': {
          borderBottom: `2px solid ${theme.palette.primary.light}`,
          marginBottom: -2,
        },
      },
    } as const)
);

const ObjektLankHeader: React.FC<React.PropsWithChildren<IProps>> = props => {
  const { classes, cx } = useStyles();
  return (
    <EDTypography
      color="inherit"
      className={cx({
        [classes.valueText]: !!props.label && !props.disableClickable,
      })}
      onClick={!props.disableClickable ? props.onClick : undefined}
      bold={!props.disableClickable ? Boolean(props.label) : undefined}
      testId={props.testId}
    >
      {props.label || '—'}
    </EDTypography>
  );
};

export default ObjektLankHeader;
